import React from 'react';
import { observer } from 'mobx-react-lite';
import { OrderIcon, CalendarIcon, SettingsIcon } from './Icons';

interface BottomNavigationProps {
  activeTab: 'orders' | 'calendar' | 'settings';
  onTabChange: (tab: 'orders' | 'calendar' | 'settings') => void;
}

export const BottomNavigation = observer(({ activeTab, onTabChange }: BottomNavigationProps) => {
  const tabs = [
    { key: 'orders', label: 'Orders', Icon: OrderIcon },
    { key: 'calendar', label: 'Calendar', Icon: CalendarIcon },
    { key: 'settings', label: 'Settings', Icon: SettingsIcon },
  ] as const;

  return (
    <nav className="bg-white border-t border-gray-200 shadow-[0_-2px_8px_rgba(0,0,0,0.05)]">
      <div className="flex flex-row justify-around items-center h-14">
        {tabs.map((tab) => {
          const isActive = activeTab === tab.key;
          const iconColor = isActive ? '#00B2A8' : '#6B7280';

          return (
            <button
              key={tab.key}
              onClick={() => onTabChange(tab.key)}
              className={`flex-1 flex flex-col items-center justify-center py-2 ${
                isActive ? 'opacity-100' : 'opacity-40'
              }`}
            >
              <tab.Icon size={24} color={iconColor} />
              <span
                className={`text-xs font-medium mt-1 ${
                  isActive ? 'text-[#00B2A8]' : 'text-gray-600'
                }`}
              >
                {tab.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
});
